import React from "react";
import Social from "../Social";

const About = () => {
  return (
    <>
      <section id="about" className="section theme-light dark-bg">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="about-me">
                <div className="img">
                  <div className="img-in">
                    <img src="img/about/about-me.jpg" alt="Rahaf Shora" />
                  </div>
                  <Social />
                  {/* End social icon */}
                </div>
                {/* End img */}
                <div className="info">
                  <p>Full Stack Developer</p>
                  <h3>Rahaf Shora</h3>
                </div>
                {/* End info */}
              </div>
              {/* End about-me */}
            </div>
            {/* End col */}

            <div className="col-lg-7 ml-auto">
              <div className="about-info">
                <div className="title">
                  <h3>Biography</h3>
                </div>
                <div className="about-text">
                  <p>
                    Full-Stack Web Developer passionate about the customer
                    journey and developing innovative solutions using modern web
                    technologies Well-versed in HTML, CSS, JavaScript, React and
                    PHP to create visually appealing web application while
                    handling cross-browser problems , with a strong skill such
                    as team leadership and problem solving
                  </p>
                </div>
                <div className="info-list">
                  <div className="row">
                    <div className="col-sm-6">
                      <ul>
                        <li>
                          <label>Name: </label>
                          <span>Rahaf Shora</span>
                        </li>
                        <li>
                          <label>Address: </label>
                          <span>Wales , United Kingdom</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <ul>
                        <li>
                          <label>Email: </label>
                          <span>Rahaf.it@gmail.com</span>
                        </li>
                        <li>
                          <label>Freelance: </label>
                          <span>Available</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
